var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m44.459 29.757-7.046 6.012a13.691 13.691 0 0 0-5.167 10.8q0 3.852 4.6 8.924t4.6 9.3q0 13.809-13.621 13.809-14.562 0-14.561-16.628 0-24.892 24.9-40.582Zm42.272 0-7.046 6.012a13.691 13.691 0 0 0-5.167 10.8q0 3.852 4.6 8.924t4.6 9.3q0 13.809-13.621 13.809-14.562 0-14.561-16.628 0-24.892 24.9-40.582Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.4835c15f5164bbbb6e6aae1dc6f51ed2.svg";
export { ForwardRef as ReactComponent };